import { TextValidations } from '../constants/regex';

export const getSingleValidation = (
  val = '',
  validation = [],
  validationDetails = {},
  regexMap = {},
) => {
  switch (validation) {
    case TextValidations.NOT_EMPTY_NO_SPACE:
      return !!val.trim();

    case TextValidations.NOT_EMPTY:
      return !!val;

    case TextValidations.MIN_CHAR_COUNT:
      return val.length >= validationDetails[validation];

    case TextValidations.MAX_CHAR_COUNT:
      return val.length <= validationDetails[validation];

    case TextValidations.TEXT_MATCH:
      return val === validationDetails[validation];

    default:
      if (regexMap[validation] && regexMap[validation].validation) {
        return regexMap[validation].validation.test(val);
      }
      return true;
  }
};

export const getMultipleValidations = (
  value = '',
  validations = [],
  validationDetails = {},
  regexMap = {},
) => {
  const failedValidations = [];

  validations.forEach((validation) => {
    if (!getSingleValidation(value, validation, validationDetails, regexMap)) {
      failedValidations.push(validation);
    }
  });

  return failedValidations;
};
